<template>
  <div class="current-bid-title border-bottom">
    <h5 class="fw-bold">Agregar usuarios al Remate</h5>
    <div class="col-md-12 mt-4">
      <basic-label title="Usuarios" class="fw-bold" />
      <v-select
        label="name"
        :options="users"
        placeholder="Seleccione los usuarios que agregará al remate"
        v-model="usersSelected"
        :multiple="true"
        :reduce="(item) => item.id"
        class="mt-md-1"
      >
        <template #option="{ attributes }">
          <h6 style="margin: 0">{{ attributes.name }}</h6>
          <small style="margin: 0"
            >{{ attributes.rut }} | {{ attributes.email }}</small
          >
        </template>
      </v-select>

      <div class="d-flex mt-4 justify-content-end">
        <button-filled
          @click="sendParticipants"
          class="blog-btn fw-bolder mb-2"
          :hasRoundedCorners="true"
          :text="'Agregar Participantes'"
          size="small"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BasicLabel from "@/components/atoms/FormInput/BasicLabel.vue";
import ButtonFilled from "@/components/atoms/Button/ButtonFilled.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  props: {
    fetchFunction: { type: Function },
  },
  components: { BasicLabel, ButtonFilled, "v-select": vSelect },
  data() {
    return {
      users: [],
      usersSelected: [],
      // Data Params
      slug: this.$route.params.slug,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const { data } = await axios.get(
        `/api/users/search-non-participants/${this.slug}`
      );
      this.users = data.users.map((item) => {
        return {
          ...item,
          name: item.attributes.name,
        };
      });
    },
    // Enviar participantes al remate
    sendParticipants() {
      this.$store.commit("forceCloseModal");
      this.$swal({
        title: "¿Está seguro?",
        text: "¿Desea agregar estos usuarios como participantes del remate?",
        icon: "info",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Enviar",
      }).then(async (result) => {
        if (result.value) {
          let loader = this.$loading.show();
          try {
            const { data } = await axios.post(
              `/api/auctions/${this.slug}/participants`,
              {
                users: this.usersSelected,
              }
            );
            this.$swal({
              icon: "success",
              title: "Excelente",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            }).then(async () => {
              this.usersSelected = [];
              await this.fetchFunction();
            });
          } catch (e) {
            return e;
          } finally {
            loader.hide();
          }
        }
      });
    },
  },
};
</script>

<style></style>
